import { getSvgIcon, InterfaceIcon } from '@helpers/icons';
import { getSrcs } from '@helpers/image';
import { Device, until } from '@helpers/media';
import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import { SocialMediaIcon } from '@stories/Components/Misc/SocialLinks/SocialLinks';
import * as React from 'react';
import S from './PersonCard.styles';
const PersonCard = (props) => {
    const imageSrc = props.image ? getSrcs(props.image, 244, 164, 2, 1 / 1) : null;
    return (React.createElement(S.Container, { "data-variant": props.variant },
        React.createElement(S.Grid, { "data-has-company": !!props.company },
            imageSrc?.src && (React.createElement(S.ImageContainer, null, props.image && (React.createElement(S.Image, { src: imageSrc.src, srcSet: imageSrc.srcSet, sizes: `${until(Device.Tablet)} 164px, 244px`, alt: props.image.altText, loading: "lazy" })))),
            React.createElement(S.ProfileArea, null,
                React.createElement(S.Heading, { as: props.headingType }, props.name),
                props.jobTitle && React.createElement(S.Subheading, null, props.jobTitle),
                props.company && React.createElement(S.Company, null, props.company)),
            React.createElement(S.MainContentHolder, null,
                props.description && (React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.description } })),
                (props.linkedIn || props.telNumber) && (React.createElement(S.ContactArea, null,
                    props.linkedIn && (React.createElement(S.LinkedIn, { href: props.linkedIn.url, target: "_blank" },
                        getSvgIcon(SocialMediaIcon.LinkedIn),
                        " ",
                        props.linkedIn.text)),
                    props.telNumber && (React.createElement(S.TelNumber, { href: `tel:${props.telNumber}` },
                        getSvgIcon(InterfaceIcon.Phone),
                        " ",
                        props.telNumber)))),
                (props.cta || props.email) && (React.createElement(S.CtaArea, null,
                    props.cta && (React.createElement(LinkButton, { href: props.cta.url, buttonType: "tertiary", icon: InterfaceIcon.ArrowRight, iconOnly: false }, props.cta.text)),
                    props.email && (React.createElement(LinkButton, { href: `mailto:${props.email.url}`, buttonType: "secondary", icon: InterfaceIcon.Mail, iconOnly: false }, props.email.text))))))));
};
export default PersonCard;
